import { Zoom } from "@material-ui/core"
import React from "react"

import { TipWrap, Location, MapMark } from "../styles/GobalTeam.styled"
import { SAFlag } from "../utils/Flags"

import { HubToolTip } from "./LocationToolTipNew"

const CapeTown = ({ showCapeTown, setShowCapeTown }) => (
  <HubToolTip
    TransitionComponent={Zoom}
    title={
      <TipWrap>
        <SAFlag className="flag" />
        <span>Cape Town, SA</span>
      </TipWrap>
    }
    placement="top"
    arrow
    enterTouchDelay={0}
    leaveTouchDelay={2500}
    open={showCapeTown}
    onOpen={() => setShowCapeTown(true)}
    onClose={() => setShowCapeTown(false)}
  >
    <Location className="cape-town">
      <MapMark />
    </Location>
  </HubToolTip>
)

export default CapeTown
